import BaseModel from "@/app/base/BaseModel";

export default class UserProfileModel extends BaseModel {
    constructor(props) {
        super(props)
        this.keyName = ''
        this.keyValue = ''
        this.keyType = UserProfileModel.KEY_TYPE.text
        this.syncProps(props)
    }
}

UserProfileModel.KEY_TYPE = {
    text: 'Text',
    textArea: 'Long text',
    html: 'Html',
    image: 'Image'
}
